import { useRouter } from 'vue-router';

export function useIdentityVerification() {
  const router = useRouter();

  const redirectBasedOnCompanyType = (companyType) => {
    switch (companyType) {
      case 'broker':
        return router.push({ name: 'CarrierWelcomePage' });
      case 'carrier':
        return router.push({ name: 'CarrierWelcomePage' });
      case 'dispatcher':
        return router.push({ name: 'Dispatcher Dashboard' });
      default:
        return router.push({ name: 'Home' });
    }
  };

  return {
    redirectBasedOnCompanyType,
  };
}
